export { default as useGetTiCardData } from "./useGetTiCardData";
